import * as React from "react";
import { Row, Col, Button } from "rsuite";
import { CSVLink } from "react-csv"
import { DATA_TABLE } from "../../config/constants";

export class CrossSellAllTogetherList extends React.Component<any, any> {
    fontSize = "0.85vw";
    headerStyle = { borderTop: "0.2px solid rgb(117, 189, 8)", fontSize: "0.8em", backgroundColor: "black", color: "white", borderRight: "0.1px solid #333231", borderBottom: "0.2px solid rgb(117, 189, 8)" };
    columnStyle = {
        backgroundColor: "#1a1916", color: "white", fontSize: "0.75em",
        borderRight: "0.1px solid #333231", borderBottom: "0.1px solid #333231", innerHeight: "36px",
    };
    constructor(props: any) {
        super(props);
    }

    render(): React.ReactNode {
        const { data, handleClose, exportData } = this.props;
        // console.log(exportData);
        
        return <>
            <Row style={{ height: "78%" }} className="show-grid">
                {(data && data.length > 0) ? <Col xs={24} sm={24} md={24} style={{ height: '100%' }}>
                    <Row className="show-grid" style={{ height: '100%' }}>
                        <table className="fixed_header crossSell" style={{ height: '100%' }}>
                            <tbody className="tbodyClass" style={{ fontSize: this.fontSize, height: '95%' }}>
                                <tr className="stickyHeader">
                                    <th className="text-center" style={this.headerStyle}>Purchased ItemId</th>
                                    <th className="text-center" style={this.headerStyle}>Purchased Description</th>
                                    <th className="text-center" style={this.headerStyle}>GoTogether ItemId</th>
                                    <th className="text-center" style={this.headerStyle}>GoTogether Description</th>
                                    <th className="text-center" style={this.headerStyle}>L3</th>
                                    <th className="text-center" style={this.headerStyle}>L4</th>
                                    <th className="text-center" style={this.headerStyle}>Recommended Quantity</th>
                                    <th className="text-center" style={this.headerStyle}> Price ($/each)</th>
                                    <th className="text-center" style={this.headerStyle}> Margin ($/each)</th>
                                    <th className="text-center" style={this.headerStyle}> Opportunity Revenue($)</th>
                                    <th className="text-center" style={this.headerStyle}> Opportunity Margin($)</th>
                                    {/* <th className="text-center" style={this.headerStyle}>Include in this?</th> */}
                                </tr>
                                {data.map((d: any, index: number) =>
                                    <tr key={index}>
                                        <td className="text-center" style={this.columnStyle}>{d.itemIdBrought_BroughtDesc.split("_")[0]}</td>
                                        <td className="text-center" style={this.columnStyle}>{d.itemIdBrought_BroughtDesc.split("_")[1]}</td>
                                        <td className="text-center" style={this.columnStyle}>{d.itemId_Desc.split("_")[0]}</td>
                                        <td className="text-center" style={this.columnStyle}>{d.itemId_Desc.split("_")[1]}</td>
                                        <th className="text-center" style={this.columnStyle}>{d.l3}</th>
                                        <th className="text-center" style={this.columnStyle}>{d.l4}</th>
                                        <td className="text-center" style={this.columnStyle}>{Number(d.quantity.toFixed(0)).toLocaleString()}</td>
                                        <td className="text-center" style={this.columnStyle}>{"$"+ d.price.toFixed(2)}</td>
                                        <td className="text-center" style={this.columnStyle}>{"$"+ d.margin.toFixed(2)}</td>
                                        <td className="text-center" style={this.columnStyle}>{"$"+ d.OpportunityRevenue.toFixed(2)}</td>
                                        <td className="text-center" style={this.columnStyle}>{"$"+ d.OpportunityMargin.toFixed(2)}</td>
                                        {/* <td className="text-center" style={this.columnStyle}>{d.include == 1 ? 'Yes' : 'No'}</td> */}
                                    </tr>)}
                            </tbody>
                        </table>
                    </Row>
                </Col> : <span className="divTextCenter">Please apply filter to see the data</span>}
            </Row >
            <Row style={{ height: '5%' }}>
                <div className="button-flex">
                    <Button className="buttonMargin" color="green"
                        style={{ fontSize: "0.7vw" }}
                         appearance="default">
                            <CSVLink
                data={exportData}
                headers={DATA_TABLE}
                filename={"goTogetherList"}
              >
                Download
              </CSVLink>
                </Button>

                    <Button className="buttonMargin" color="red"
                        style={{ fontSize: "0.7vw" }}
                        onClick={handleClose} appearance="default">Close</Button>
                </div>
            </Row>
        </>
    }
}